import http from '../../services/http-common';

class ProductService {
  getProductForList(id) {
    return http.get(`/Product/sp/list/${id}`);
  }
  insert(data) {
    return http.post(`/Product/db/add`, data);
  }
  update(data) {
    return http.put(`/Product/db/edit`, data);
  }
  delete(PropertyID) {
    return http.delete(`/Product/db/delete/${PropertyID}`);
  }
}

export default new ProductService();